module.exports = __webpack_public_path__ + "img/logo-square.fdb27595.png";